<template>
    <!--
    作者：bbc_team
    时间：2023-06-08
    描述：插件中心-积分商城-商品设置-添加商品
  -->
    <div class="pb50">
        <el-form v-if="!loading" ref="form" size="small" :model="form" label-width="150px">
            <!--商品信息-->
            <Info></Info>

            <!--规格-->
            <Spec></Spec>

            <Other></Other>

            <!--提交-->
        </el-form>

        <div class="common-button-wrapper">
            <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
            <el-button size="small" type="primary" :loading="loading" @click="onSubmit">提交</el-button>
        </div>
    </div>
</template>
<script>
    import BargainApi from "@/api/bargain";
    import Info from "./part/Info.vue";
    import Spec from "./part/Spec.vue";
    import Other from "./part/Other.vue";
    import { formatModel } from "@/utils/base.js";
    export default {
        components: {
            /*产品基本信息*/
            Info,
            /*规格*/
            Spec,
            /*其它*/
            Other
        },
        provide: function() {
            return {
                form: this.form,
                type: "add"
            };
        },
        data() {
            return {
                /*是否正在加载*/
                loading: true,
                /*表单*/
                form: {
                    /*商品ID*/
                    goods_id: 0,
                    /*活动ID*/
                    bargain_activity_id: 0,
                    /*商品状态*/
                    status: 10,
                    /*商品名称*/
                    goods_name: "",
                    /*规格*/
                    goods_sku_id: 0,
                    /*商品表格*/
                    tableData: [],
                    /*活动名称*/
                    active_name: "",
                    limit_num: ""
                }
            };
        },
        created() {
            if (this.$route.query.goods_id != null) {
                this.form.goods_id = this.$route.query.goods_id;
                this.form.bargain_activity_id = this.$route.query.bargain_activity_id;
                this.getData();
            }
        },
        methods: {
            /*获取商品*/
            getData() {
                let self = this;
                BargainApi.getGoods(
                    {
                        goods_id: self.form.goods_id,
                        bargain_activity_id: self.form.bargain_activity_id
                    },
                    true
                ).then((res) => {
                    Object.assign(self.form, res.data.model);
                    self.form.active_name = res.data.active.title;
                    self.creatSpec();
                    self.loading = false;
                });
            },

            /*格式规格表格数据*/
            creatSpec() {
                let self = this;
                let obj = {
                    goods_name: self.form.goods_name,
                    goods_id: self.form.goods_id,
                    goods_price: self.form.goods_price,
                    stock_num: self.form.goods_stock,
                    goods_sku_id: self.form.goods_sku.goods_sku_id,
                    spec_type: self.form.spec_type,
                    bargain_price: 0,
                    bargain_stock: 0,
                    bargain_num: 0,
                    tempGoods: true,
                    bargain_goods_id: 0,
                    bargain_goods_sku_id: 0
                };
                self.form.tableData.push(obj);
            },

            /*提交表单*/
            onSubmit() {
                let self = this;
                self.$refs.form.validate((valid) => {
                    if (valid) {
                        let params = {
                            goods: {}
                        };
                        params.goods_id = self.form.goods_id;
                        params.bargain_activity_id = self.form.bargain_activity_id;
                        params.limit_num = self.form.limit_num;
                        params.goods.spec_list = self.tableFormet(self.form.tableData);
                        self.loading = true;
                        BargainApi.addGoods(params, true)
                            .then((data) => {
                                self.loading = false;
                                self.$message({
                                    message: "恭喜你，添加成功",
                                    type: "success"
                                });
                                self.cancelFunc();
                            })
                            .catch((error) => {
                                self.loading = false;
                            });
                    }
                });
            },

            /*表格数据格式化*/
            tableFormet(list) {
                list.forEach((item) => {
                    item.goods_attr = item.spec_name != null ? item.spec_name : "";
                });
                return list;
            },

            /*取消*/
            cancelFunc() {
                this.$router.back(-1);
            }
        }
    };
</script>
<style>
    .edit_container {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/activity/bargain/add.vue